import { useState, useEffect } from 'react';
import './Works.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

function Works() {
  const [works, setWorks] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/works.php`)
      .then(res => res.json())
      .then(data => setWorks(data))
      .catch(err => console.error('Failed to load works:', err));
  }, []);

  const buildFilter = (gamma, brightness) => {
    const parts = [];
    if (gamma) parts.push(`brightness(${1 + gamma})`);
    if (brightness) {
      // Positive: reduce contrast and boost brightness to add white
      // Negative: reduce contrast and lower brightness to add black
      const contrast = 1 - Math.abs(brightness) * 0.8;
      const bright = 1 + brightness * 0.5;
      parts.push(`contrast(${contrast})`);
      parts.push(`brightness(${bright})`);
    }
    return parts.length ? parts.join(' ') : undefined;
  };

  const formatDimensions = (w, h) => {
    if (!w || !h) return null;
    return `${(w / 100).toFixed(0)}" × ${(h / 100).toFixed(0)}"`;
  };

  return (
    <div className="works">
      {works.length === 0 ? (
        <p className="works-placeholder">New gallery coming soon.</p>
      ) : (
        <div className="works-grid">
          {works.map(work => {
            const [cols, rows] = (work.grid_type || '1x1').split('x').map(Number);
            const cx1 = work.crop_x1 ?? 0;
            const cy1 = work.crop_y1 ?? 0;
            const cx2 = work.crop_x2 ?? 1;
            const cy2 = work.crop_y2 ?? 1;
            const cropW = cx2 - cx1;
            const cropH = cy2 - cy1;
            const bgSize = `${100 / cropW}% ${100 / cropH}%`;
            const posX = cropW >= 1 ? 0 : (cx1 / (1 - cropW)) * 100;
            const posY = cropH >= 1 ? 0 : (cy1 / (1 - cropH)) * 100;
            return (
              <div
                key={work.uid}
                className="works-thumb"
                style={{
                  gridColumn: `span ${cols}`,
                  gridRow: `span ${rows}`,
                  backgroundImage: `url(${API_BASE}/../uploads/full/${work.uid}.png)`,
                  backgroundSize: bgSize,
                  backgroundPosition: `${posX}% ${posY}%`,
                  filter: buildFilter(work.gamma, work.brightness),
                }}
                onClick={() => setSelected(work)}
              />
            );
          })}
        </div>
      )}

      {selected && (
        <div className="works-overlay" onClick={() => setSelected(null)}>
          <div className="works-viewer" onClick={e => e.stopPropagation()}>
            <button className="works-close" onClick={() => setSelected(null)}>&times;</button>
            <div className="canvas-wrap">
              <img
                src={`${API_BASE}/../uploads/full/${selected.uid}.png`}
                alt={selected.title || 'Untitled'}
                className="canvas-face"
                style={{ filter: buildFilter(selected.gamma, selected.brightness) }}
              />
              <div
                className="canvas-edge-right"
                style={{
                  backgroundImage: `url(${API_BASE}/../uploads/full/${selected.uid}.png)`,
                }}
              />
              <div
                className="canvas-edge-bottom"
                style={{
                  backgroundImage: `url(${API_BASE}/../uploads/full/${selected.uid}.png)`,
                }}
              />
            </div>
            <div className="works-info">
              {selected.title && <h2>{selected.title}</h2>}
              {selected.medium && <p className="works-medium">{selected.medium}</p>}
              {formatDimensions(selected.width, selected.height) && (
                <p className="works-dimensions">{formatDimensions(selected.width, selected.height)}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Works;
